import script from "./IconInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./IconInfo.vue?vue&type=script&setup=true&lang=js"

import "./IconInfo.vue?vue&type=style&index=0&id=5680b740&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5680b740"]])

export default __exports__